export enum TestType {
  Normal = 1,
  Ratio = 2,
  BillOnly = 4,
  Panel = 8,
  SuperPanel = 16, // 0x00000010
  Microbiology = 32, // 0x00000020
  Toxicology = 64, // 0x00000040
  ToxicologyRatio = 128, // 0x00000080
  Pathology = 256, // 0x00000100
  None = 512, // 0x00000200
  All = Pathology | ToxicologyRatio | Toxicology | Microbiology | SuperPanel | Panel | BillOnly | Ratio | Normal, // 0x000001FF
}
